import React from 'react';
import PropTypes from 'prop-types';
import styles from './OneSessionToggle.module.scss';

const OneSessionToggle = ({ visible, onClick }) => {
  if (!visible) return null;

  return (
    <div className={styles.toggleWrapper}>
      <button onClick={onClick} className={styles.toggleButton}>
        I want to book sessions individually
      </button>
    </div>
  );
};

OneSessionToggle.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default OneSessionToggle;
